import React, { useState } from "react";
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import DynamicProfileEditor from "../Components/DynamicQuestionnaire/client/editor/DynamicProfileEditor";
import AdminCard from "../Components/ui/AdminCard";

/**
 * TestEditor Page
 * A test environment for the DynamicProfileEditor component
 */
const TestEditor = () => {
  const { responseId: urlResponseId, questionnaireId } = useParams();
  const [responseId, setResponseId] = useState(urlResponseId || "");
  const [showEditor, setShowEditor] = useState(!!urlResponseId);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (responseId.trim()) {
      setShowEditor(true);
    }
  };

  // If we have a responseId from the URL, show the editor directly
  React.useEffect(() => {
    if (urlResponseId) {
      setResponseId(urlResponseId);
      setShowEditor(true);
    }
  }, [urlResponseId]);

  return (
    <div className="bg-[#111111] min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-4">
              Brand Profile Editor
            </h1>
            <p className="text-gray-300 mb-8">
              Edit your brand profile content, customize display options, and
              create a shareable URL.
            </p>
          </div>

          {!showEditor ? (
            <AdminCard className="p-6">
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <div className="mb-4">
                  <label
                    htmlFor="responseId"
                    className="block text-white font-medium mb-2"
                  >
                    Response ID
                  </label>
                  <input
                    type="text"
                    id="responseId"
                    value={responseId}
                    onChange={(e) => setResponseId(e.target.value)}
                    placeholder="Enter response ID"
                    className="w-full bg-gray-800 border border-gray-700 rounded-md p-3 text-white"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-primary-green hover:bg-primary-green/90 text-black font-medium py-3 px-4 rounded-md"
                >
                  Load Profile Data
                </button>
              </form>
            </AdminCard>
          ) : (
            <AdminCard>
              <div className="p-6 border-b border-white/10 mb-4">
                <button
                  onClick={() => setShowEditor(false)}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md"
                >
                  Back to ID Entry
                </button>
              </div>
              <div className="p-6">
                <DynamicProfileEditor
                  responseId={responseId}
                  questionnaireId={questionnaireId}
                />
              </div>
            </AdminCard>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default TestEditor;
